exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PromisedPayment_promisedPaymentContainer_2UIS {\n  margin-top: 10px;\n}\n\n.PromisedPayment_statusIndicator_3kbB {\n  margin-right: 7px;\n\n  display: inline-block;\n  vertical-align: middle;\n\n  width: 10px;\n  height: 10px;\n\n  border-radius: 50%;\n  background-color: #0c0\n}\n\n.PromisedPayment_statusIndicator_3kbB.PromisedPayment_warn_1LYL {\n  background-color: #ffb13e;\n}\n\n.PromisedPayment_serviceDescription_2Gf3 {\n  margin-top: 5px;\n  margin-left: 17px;\n\n  display: block;\n\n  font-size: 15px;\n\n  color: #787878\n}\n\n.PromisedPayment_serviceDescription_2Gf3.PromisedPayment_temporary_D5-f {\n  margin-left: 5px;\n  display: inline;\n}\n", ""]);

// exports
exports.locals = {
	"promisedPaymentContainer": "PromisedPayment_promisedPaymentContainer_2UIS",
	"statusIndicator": "PromisedPayment_statusIndicator_3kbB",
	"warn": "PromisedPayment_warn_1LYL",
	"serviceDescription": "PromisedPayment_serviceDescription_2Gf3",
	"temporary": "PromisedPayment_temporary_D5-f"
};